export const POST_SIGNUP = "kopaproLicense/signup/postSignup";
export const POST_SGINUP_SUCCESS = "kopaproLicense/signup/postSignupSuccess";

export const UPDATE_SIGNUP = "kopaproLicense/signup/updateSignup";
export const CLEAR_SIGNUP = "kopaproLicense/signup/clearSignup";

const initialState = {   
    email: '',
    password: '',
    saved: false,
    trial:true,
    code: '',
    desc:'',
    plan:'su',
    error: {}       
}

export default function reducer(state=initialState ,action){
    switch(action.type){       
        case POST_SGINUP_SUCCESS:            
            return {
                ...state,
                email:'',
                password: '',
                saved: action.payload.saved ,
                error: action.payload.error
            }
        case UPDATE_SIGNUP:
            //console.log(action);
            
            return{
                ...state,
                ...action.payload.data
            }
        case CLEAR_SIGNUP:
            console.log('clear signup')
            return {...initialState}
        default:            
        return state;
    }
}

export const postSignup = (data,callback) => ({
    type: POST_SIGNUP,payload:{
        data:data,
        callback:callback
    }
})

export const updateSignup = (data) => ({
    type: UPDATE_SIGNUP, payload:{
        data:data
    }
})


export const clearSignup = () => ({
    type: CLEAR_SIGNUP
})
